@switch (state) {
  @case ('hotels-map') {
    <app-hotel-map-mobile
      [hotels]="clonedItems"
      [countryName]="data.countryName"
      [cityName]="data.cityName"
      [cityId]="data.cityId"
    ></app-hotel-map-mobile>
  }
  @case ('hotels-filters') {
    <app-hotel-filters-mobile
      [filters]="hotelFilters"
      (onApply)="applyHotelFiltersHandler($event)"
    ></app-hotel-filters-mobile>
  }
  @case ('occasion-genius-filters') {
    <app-occasion-genius-filters-mobile
      [filters]="occasionGeniusFilters"
      [occasionGeniusResponse]="data.occasionGeniusResponse"
      (onApply)="applyOccasionGeniusFiltersHandler($event)"
    ></app-occasion-genius-filters-mobile>
  }
  @default {
    <div class="hotel-list-filters">
      <div class="hotel-list-filters__header">
        @if (data.packages$ | async; as packages) {
          @if (packages.length) {
            <div class="hotel-list-filters__navigation">
              <button
                class="hotel-list-filters__navigation--prev"
                [disabled]="!packages[data.currentDestinationIndex - 1]"
                (click)="prevCity()"
              >
                <mat-icon [svgIcon]="eSvgIcons.ARROW_RIGHT_1"></mat-icon>
                <span>{{ packages[data.currentDestinationIndex - 1]?.name }}</span>
              </button>

              <div class="hotel-list-filters__navigation--info">
                <div class="hotel-list-filters__navigation--title">
                  {{ packages[data.currentDestinationIndex]?.name }}
                </div>
                <div class="hotel-list-filters__navigation--count">
                  {{ packages[data.currentDestinationIndex]?.days }} nights
                </div>
              </div>

              <button class="hotel-list-filters__navigation--next"
                      [disabled]="!packages[data.currentDestinationIndex + 1]"
                      (click)="nextCity()"
              >
                <span>{{ packages[data.currentDestinationIndex + 1]?.name }}</span>
                <mat-icon [svgIcon]="eSvgIcons.ARROW_RIGHT_1"></mat-icon>
              </button>
            </div>
          } @else {
            <div class="hotel-list-filters__navigation">
              <button class="hotel-list-filters__navigation--prev"
                      [disabled]="!packages[data.currentDestinationIndex - 1]"
                      (click)="prevCity()"
              >
                <mat-icon [svgIcon]="eSvgIcons.ARROW_RIGHT_1"></mat-icon>
                <ngx-skeleton-loader
                  [theme]="{'margin': '0 0 0 5px', 'display': 'inline-block', 'height': '18px', 'width': '20px'}"></ngx-skeleton-loader>
              </button>

              <div class="hotel-list-filters__navigation--info">
                <div class="hotel-list-filters__navigation--title">
                  <ngx-skeleton-loader
                    [theme]="{'margin': '0', 'display': 'inline-block', 'height': '10px', 'width': '40px'}"></ngx-skeleton-loader>
                </div>
                <div class="hotel-list-filters__navigation--count">
                  <ngx-skeleton-loader
                    [theme]="{'margin': '0', 'display': 'inline-block', 'height': '10px', 'width': '30px'}"></ngx-skeleton-loader>
                  nights
                </div>
              </div>

              <button class="hotel-list-filters__navigation--next">
                <ngx-skeleton-loader
                  [theme]="{'margin': '0 5px 0 0', 'display': 'inline-block', 'height': '10px', 'width': '20px'}"></ngx-skeleton-loader>
                <mat-icon [svgIcon]="eSvgIcons.ARROW_RIGHT_1"></mat-icon>
              </button>
            </div>
          }
        }

        @if (ETripCityInfoType.OCCASION_GENIUS === data.pageType) {
          <div class="hotel-list-filters__header--relative hotel-list-filters__header--full" style="margin-bottom: 16px">
            <button class="hotel-list-filters__filter hotel-list-filters__filter--full" (click)="selectRef.open()">
              <span class="hotel-list-filters__filter--label">Select category</span>
              <mat-icon class="hotel-list-filters__filter--down" [svgIcon]="eSvgIcons.ARROW_RIGHT"></mat-icon>
            </button>
            <mat-select placeholder="Sorting" (valueChange)="setOccasionGroupType($event)" #selectRef>
              @for (item of data.occasionGeniusResponse.categoriesOptions; track item.label; let index = $index) {
                <mat-option [value]="item.value">{{ item.label | titlecase }}</mat-option>
              }
            </mat-select>
          </div>
        }

        <div class="hotel-list-filters__header--filters">
          @if (ETripCityInfoType.BOOKING === data.pageType) {
            <button class="hotel-list-filters__filter hotel-list-filters__filter--circle"
                    [disabled]="!clonedItems?.length"
                    (click)="searchHotel()">
              <mat-icon class="hotel-list-filters__filter--icon" [svgIcon]="eSvgIcons.SEARCH"></mat-icon>
            </button>
            <div class="hotel-list-filters__header--relative">
              <button class="hotel-list-filters__filter" [disabled]="!data.packages$.value.length"
                      (click)="selectRef.open()">
                <mat-icon class="hotel-list-filters__filter--icon" [svgIcon]="eSvgIcons.SORT"></mat-icon>
                <span class="hotel-list-filters__filter--label">Sort By</span>
              </button>
              <mat-select placeholder="Sorting" (valueChange)="
              hotelFilters.sort = $event; fetchHotelsWithFilters(hotelFilters)" #selectRef>
                @for (option of sortingOptions; track option.value) {
                  <mat-option [value]="option.value">{{ option.text }}</mat-option>
                }
              </mat-select>
            </div>

            <button class="hotel-list-filters__filter" [disabled]="!data.packages$.value.length"
                    (click)="setState('hotels-filters')">
              <mat-icon class="hotel-list-filters__filter--icon" [svgIcon]="eSvgIcons.FILTER"></mat-icon>
              <span class="hotel-list-filters__filter--label">Filters</span>
            </button>

            <button class="hotel-list-filters__filter hotel-list-filters__filter--circle"
                    [disabled]="!data.packages$.value.length"
                    (click)="setState('hotels-map')">
              <mat-icon class="hotel-list-filters__filter--icon" [svgIcon]="eSvgIcons.MAP"></mat-icon>
            </button>
          }

          @if (ETripCityInfoType.VIATOR === data.pageType) {
            <div class="hotel-list-filters__header--relative hotel-list-filters__header--full">
              <button class="hotel-list-filters__filter hotel-list-filters__filter--full" (click)="selectRef.open()">
                <span class="hotel-list-filters__filter--label">Select category</span>
                <mat-icon class="hotel-list-filters__filter--down" [svgIcon]="eSvgIcons.ARROW_RIGHT"></mat-icon>
              </button>
              <mat-select placeholder="Sorting" (valueChange)="setViatorGroupIndex($event)" #selectRef>
                @for (group of data.groupViator; track group.type; let index = $index) {
                  <mat-option [value]="index">{{ group.type | titlecase }}</mat-option>
                }
              </mat-select>
            </div>
          }

          @if (ETripCityInfoType.OCCASION_GENIUS === data.pageType) {
            <div class="hotel-list-filters__header--search hotel-list-filters__header--full" (click)="inputRef.focus()">
              <mat-icon [svgIcon]="eSvgIcons.SEARCH"></mat-icon>
              <input (input)="onSearch(inputRef.value)" placeholder="Search" type="text" #inputRef>
            </div>

            <button class="hotel-list-filters__filter hotel-list-filters__filter--circle"
                    (click)="setState('occasion-genius-filters')">
              <mat-icon class="hotel-list-filters__filter--icon" [svgIcon]="eSvgIcons.FILTER"></mat-icon>
            </button>
          }
        </div>
      </div>
      <div class="hotel-list-filters__content">
        <div class="hotel-list-filters__list">
          <div class="hotel-list-filters__details">
            <div class="hotel-list-filters__details--text">
              @switch (data.pageType) {
                @case (ETripCityInfoType.BOOKING) {
                  <div class="hotel-list-filters__details--info">
                    @if (data.packages$ | async; as packages) {
                      @if (packages.length) {
                        <span><span class="bold">{{ data.cityName }} hotels</span> by</span>
                        <span class="hotel-list-filters__details--date">
                            {{ data.packages$.value[data.currentDestinationIndex].dates.from | date: 'MMM d, y' }}
                          - {{ packages[data.currentDestinationIndex].dates.to | date: 'MMM d, y' }}
                        </span>
                      } @else {
                        <span><span class="bold"><ngx-skeleton-loader
                          [theme]="{'margin': '0', 'display': 'inline-block', 'height': '10px', 'width': '30px'}"></ngx-skeleton-loader> hotels</span> by</span>
                        <span class="hotel-list-filters__details--date">
                          <ngx-skeleton-loader
                            [theme]="{'margin': '0', 'display': 'inline-block', 'height': '10px', 'width': '30px'}"></ngx-skeleton-loader> -
                            <ngx-skeleton-loader
                              [theme]="{'margin': '0', 'display': 'inline-block', 'height': '10px', 'width': '30px'}"></ngx-skeleton-loader>
                        </span>
                      }
                    }
                  </div>
                }
                @case (ETripCityInfoType.VIATOR) {
                  <span><span class="bold">{{ clonedItems?.length }}</span> {{ data.countryName }} activities</span>
                }
                @case (ETripCityInfoType.OCCASION_GENIUS) {
                  <span>{{ data.cityName }} <span
                    class="bold">{{ clonedItems?.length }}</span> events and occasions</span>
                }
                @case (ETripCityInfoType.VOICE_GUIDE) {
                  <span><span class="bold">{{ clonedItems?.length }}</span> items of trips</span>
                }
              }
            </div>
            <div class="hotel-list-filters__details--image">
              @switch (data.pageType) {
                @case (ETripCityInfoType.BOOKING) {
                  <mat-icon [svgIcon]="eSvgIcons.BOOKING"></mat-icon>
                }
                @case (ETripCityInfoType.VIATOR) {
                  <mat-icon [svgIcon]="eSvgIcons.VIATOR"></mat-icon>
                }
              }
            </div>
          </div>
          @if (clonedItems && clonedItems.length) {
            <cdk-virtual-scroll-viewport [itemSize]="250">
              <div *cdkVirtualFor="let item of clonedItems; let index = index">
                @switch (data.pageType) {
                  @case (ETripCityInfoType.BOOKING) {
                    <div [id]="'hotel-el-' + index" style="padding: 0 12px 16px">
                      <app-hotel-card-mobile
                        [countryName]="data.countryName"
                        [cityName]="data.cityName"
                        [cityId]="data.cityId"
                        [hotel]="item"
                        [isFetching]="data.isFetching"
                      ></app-hotel-card-mobile>
                    </div>
                  }
                  @case (ETripCityInfoType.VIATOR) {
                    <div style="padding: 0 12px 16px">
                      <app-viator-card-mobile
                        [viator]="item"
                        [cityId]="data.cityId"
                        [cityName]="data.cityName"
                        [countryName]="data.countryName"
                        [isFetching]="data.isFetching"
                      ></app-viator-card-mobile>
                    </div>
                  }
                  @case (ETripCityInfoType.OCCASION_GENIUS) {
                    @if (getCardEvent(item); as cardEvents) {
                      <div style="padding: 0 12px 16px">
                        <app-occasion-genius-card-mobile
                          [isFetching]="data.isFetching"
                          [events]="cardEvents"
                          [cityId]="data.cityId"
                          [cityName]="data.cityName"
                          [countryName]="data.countryName"
                        ></app-occasion-genius-card-mobile>
                      </div>
                    }
                  }
                  @case (ETripCityInfoType.VOICE_GUIDE) {
                    <div style="padding: 0 12px 16px">
                      <app-voice-guide-card-mobile
                        [tour]="item"
                        [cityName]="data.cityName"
                        [countryName]="data.countryName"
                        [isFetching]="data.isFetching"
                      ></app-voice-guide-card-mobile>
                    </div>
                  }
                }
              </div>
            </cdk-virtual-scroll-viewport>
          } @else {
            @switch (data.pageType) {
              @case (ETripCityInfoType.BOOKING) {
                @if (!(!(data.packages$ | async)?.length || data?.isFetching)) {
                  <app-no-items-found title="EMPTY.HOTELS"></app-no-items-found>
                }
              }
              @case (ETripCityInfoType.VIATOR) {
                <app-no-items-found title="EMPTY.VIATOR"></app-no-items-found>
              }
              @case (ETripCityInfoType.OCCASION_GENIUS) {
                <app-no-items-found title="EMPTY.EVENTS"></app-no-items-found>
              }
              @case (ETripCityInfoType.VOICE_GUIDE) {
                <app-no-items-found title="EMPTY.VOICE_MAP" subtitle=""></app-no-items-found>
              }
            }
          }
          @if (!(data.packages$ | async)?.length || data?.isFetching) {
            @for (item of [1, 2, 3, 4, 5, 6]; track $index) {
              @switch (data.pageType) {
                @case (ETripCityInfoType.BOOKING) {
                  <app-hotel-card-mobile
                    [countryName]="''"
                    [cityName]="''"
                    [cityId]="''"
                    [hotel]="null"
                    [isFetching]="true"
                  ></app-hotel-card-mobile>
                }
              }
            }
          }
        </div>
      </div>
    </div>
  }
}
